import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';

import { PrescriptionViewModel } from '../view-models/prescription-view-model';
import { PrescriptionChainHandler } from './prescription-chain-handler';
import { convertArticleLines } from './prescription-chain-helpers';

// tslint:disable-next-line: max-line-length
import type { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
export class CreatePlainPrescriptionHandler extends PrescriptionChainHandler {
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const prescription = new PrescriptionViewModel();
    prescription.middleTexts = ['test1'];
    prescription.outboundDate = new Date().toISOString();
    prescription.positions = convertArticleLines(request.articleLines);
    prescriptionRequestDto.prescriptions = [prescription];
    prescriptionRequestDto.integratedCareId = request.integratedCareId;
    prescriptionRequestDto.to = request.to;
    prescriptionRequestDto.correspondenceType = request.correspondenceType;
    prescriptionRequestDto.diagnose = request.diagnose;
    prescriptionRequestDto.startDate = request.startDate;
    prescriptionRequestDto.endDate = request.endDate;
    prescriptionRequestDto.singleOrderId = request.singleOrderId;
    prescriptionRequestDto.templateId = request.templateId;
    prescriptionRequestDto.patientId = request.patientId;
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
